var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "form-group row mt-4": _vm.hasTitle } },
    [
      _vm.title
        ? _c("label-control", {
            class: { "col-xs-12 col-sm-5 col-form-label": _vm.hasTitle },
            attrs: {
              id: _vm.dropdownId,
              title: _vm.title,
              required: _vm.required
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { class: { "col-xs-12 col-sm-7": _vm.hasTitle } }, [
        _vm.options
          ? _c(
              "div",
              { staticClass: "multiselect-wrapper" },
              [
                _c("ValidationProvider", {
                  ref: "provider",
                  attrs: { rules: { required: _vm.required }, slim: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          var failedRules = ref.failedRules
                          return [
                            _c("multiselect-accessible", {
                              class: _vm.getValidationErrorClasses(failedRules),
                              attrs: {
                                options: _vm.options,
                                dropdownId: _vm.dropdownId,
                                selectedText: _vm.$t(_vm.selectedText),
                                removeText: _vm.$t("Selection.Remove"),
                                readOnly: _vm.isReadOnly,
                                maxSelected: _vm.max,
                                placeholder: _vm.placeholderText,
                                "aria-invalid":
                                  _vm.required && errors.length > 0
                              },
                              on: {
                                close: function($event) {
                                  return _vm.provider.validate()
                                }
                              },
                              model: {
                                value: _vm.inputSelectedValues,
                                callback: function($$v) {
                                  _vm.inputSelectedValues = $$v
                                },
                                expression: "inputSelectedValues"
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    1032135431
                  )
                })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }